import { Show, type JSX } from 'solid-js';
import { pause } from '../state/metrics';

function hhmm(ms: number): string {
  const d = new Date(ms);
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}

/**
 * The HUD card shell: translucent panel, clipped corners and the two bracket
 * corners. Every dashboard card is one of these, so the silhouette is defined
 * once here (and in the .hud-panel rules) rather than per widget.
 */
export function HudPanel(props: {
  title?: string;
  sub?: string;
  class?: string;
  children: JSX.Element;
}) {
  const hasHead = () => props.title != null || props.sub != null;

  return (
    <section class={`hud-panel${props.class ? ` ${props.class}` : ''}`}>
      <Show when={hasHead()}>
        <div class="hud-panel-head">
          <Show when={props.title}>{(t) => <span class="hud-panel-title">{t()}</span>}</Show>
          <Show when={props.sub}>{(s) => <span class="hud-panel-sub">{s()}</span>}</Show>
          <Show when={pause().paused}>
            <span class="hud-panel-paused" title="telemetry paused on the agent">
              ⏸ {pause().since != null ? hhmm(pause().since as number) : ''}
            </span>
          </Show>
        </div>
      </Show>
      {props.children}
    </section>
  );
}
